import React from 'react'
import type { Map } from 'immutable'
import type { EventDetails } from '@mobi/betslip/types'
import { isFobDetails } from '@mobi/betslip/helpers/typeGuards'
import { spacing } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { useObservableImmutable } from '@core/Utils/hooks'
import { ErrorMessage } from '@core/Components/Messages'
import { state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'

export const FobHeader: React.FC = () => {
  const { selectionDetails: selectionDetailsMap, bettingType } = useObservableImmutable(
    quickbetState$,
    ['selectionDetails', 'bettingType']
  )

  const selectionDetails = (
    selectionDetailsMap as unknown as Map<string, string> | undefined
  )?.toJS() as EventDetails

  if (!isFobDetails(selectionDetails)) {
    return !PRODUCTION ? (
      <ErrorMessage>selectionDetails incompatible with SportsHeader</ErrorMessage>
    ) : null
  }

  const {
    sportIconCode,
    tournamentName,
    competitionName,
    eventName,
    marketName,
    propositionName,
    handicapName,
  } = selectionDetails

  let eventInfoText = tournamentName ? `${competitionName} ${tournamentName}` : competitionName
  if (eventName !== marketName && eventName) {
    eventInfoText = `${eventInfoText} ${eventName}`
  }
  return (
    <Flex flexDirection='column' gap={spacing.sm}>
      <Flex flexDirection='column' gap={spacing.smx2}>
        <EventInfo icon={<Icon size='2.2rem' type={sportIconCode} />} eventInfo={eventInfoText} />

        <SecondaryInfo
          marketInfo={
            <>
              <span>{marketName}</span>
              {bettingType === 'fixed-odds-racing' && <span>FIXED</span>}
            </>
          }
        />
      </Flex>

      <SelectionInfo text={`${propositionName} ${handicapName ? handicapName : ''}`} />
    </Flex>
  )
}
